import { $api } from "../generated/client";

type UseGetReturnRequestLogPayloadParams = {
  shopId: string;
  returnRequestId: string;
  logId: string;
  enabled?: boolean;
};

/** The body of a log stored apart (`params.hasPayload`), fetched on demand. */
export function useGetReturnRequestLogPayload({
  shopId,
  returnRequestId,
  logId,
  enabled = true,
}: UseGetReturnRequestLogPayloadParams) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/return-requests/{returnRequestId}/logs/{logId}/payload",
    { params: { path: { shopId, returnRequestId, logId } } },
    // A payload never changes once written.
    { enabled, staleTime: Infinity },
  );
}
